import React, { createContext, useContext } from 'react'

/**
 * Data pre-fetched on the server and injected into window.__INITIAL_DATA__.
 * Currently empty – added as extension point for future server-side Firestore
 * pre-fetches (e.g. daily leaderboard, championship scores).
 */
export interface InitialData {
    /** True only during server-side renderToString — skips the loading guard in App.tsx */
    isSSR?: boolean
    // Reserved for future server-side pre-fetched data
    [key: string]: unknown
}

const InitialDataContext = createContext<InitialData>({})

export function InitialDataProvider({
    data,
    children,
}: {
    data: InitialData
    children: React.ReactNode
}) {
    return (
        <InitialDataContext.Provider value={data}>
            {children}
        </InitialDataContext.Provider>
    )
}

export function useInitialData(): InitialData {
    return useContext(InitialDataContext)
}
